export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7199.9c009505.jpg";